import qs from 'querystring';

export function stripQueryParams(url, paramsToRemove) {
  const splitUrl = url.split('?');
  const path = splitUrl[0];
  const query = qs.parse(splitUrl[1]) || {};
  paramsToRemove.forEach((param) => delete query[param]);
  return path + (Object.keys(query).length ? `?${qs.stringify(query)}` : '');
}

export function addQueryParams(url, paramsToAdd) {
  const splitUrl = url.split('?');
  const path = splitUrl[0];
  const query = qs.parse(splitUrl[1]) || {};
  for (let key in paramsToAdd) {
    if ({}.hasOwnProperty.call(paramsToAdd, key)) {
      query[key] = paramsToAdd[key];
    }
  }
  return path + (Object.keys(query).length ? `?${qs.stringify(query)}` : '');
}

// retrieves query parameter case insenstively
export function getQueryParam(queryParams, key) {
  for (let fieldName of Object.keys(queryParams)) {
    if (fieldName && fieldName.toLowerCase
      && fieldName.toLowerCase() === key.toLowerCase()) {
      return queryParams[fieldName];
    }
  }
}
